<template>
  <v-dialog :modelValue="dialog" @click:outside="$emit('updateDialog')" @keydown.esc="$emit('updateDialog')" width="750">
    <v-card>
      <v-card-title class="title-modal">
        <span class="headline">Presentación</span>
      </v-card-title>

      <v-card-text>
        <v-form ref="form">
          <div class="row">
            <div class="col">
              <v-combobox
                v-model="item.presentation_type"
                name="presentation_type"
                item-title="name"
                item-value="id"
                :items="filteredPresentationTypes"
                label="Tipo de presentacion*"
                autocomplete="off"
                :rules="[rules.requiredComboBox]"
                clearable
                @update:modelValue="onPresentationTypeChange"
                :disabled="isEdit"
              ></v-combobox>
            </div>
            <div class="col">
              <v-text-field
                autocomplete="off"
                name="barcode"
                :label="item.composite_presentation == null ? 'Codigo de barras*' : 'Codigo de barras'"
                type="text"
                v-model="item.barcode"
                :rules="item.composite_presentation == null ? [rules.required] : []"
              />
            </div>
          </div>

          <div class="row mt-0" v-if="getPresentations(item).length > 0">
            <div class="col">
              <v-combobox
                v-if="getPresentations(item).length > 0"
                v-model="item.composite_presentation"
                name="composite_presentation"
                item-title="presentation_type.name"
                item-value="id"
                :items="getPresentations(item)"
                label="Composición de otra presentacion"
                autocomplete="off"
                clearable
                :disabled="item.presentation_type == null || isEdit"
                :rules="[rules.onlySelectFromList]"
              ></v-combobox>
            </div>
            <div class="col">
              <v-text-field
                v-if="getPresentations(item).length > 0"
                :disabled="item.composite_presentation == null"
                autocomplete="off"
                name="amount_composite_presentation"
                label="Cantidad de la composición"
                :rules="[rules.decimal]"
                type="number"
                v-model="item.amount_composite_presentation"
              />
            </div>
          </div>

          <div class="row">
            <div class="col">
              <v-combobox clearable v-model="item.weight_unit" name="weight_unit" item-title="name" item-value="id" :items="weight_units" label="Unidad de peso" autocomplete="off" :rules="[rules.onlySelectFromList]"></v-combobox>
            </div>
            <div class="col">
              <v-text-field autocomplete="off" name="weight" label="Peso" :rules="item.weight ? [rules.decimal] : []" type="number" v-model="item.weight" />
            </div>
          </div>

          <div class="row">
            <div class="col-md-4">
              <v-combobox clearable v-model="item.measure_unit" name="measure_unit" item-title="name" item-value="id" :items="measure_units" label="Unidad de medida" autocomplete="off" :rules="[rules.onlySelectFromList]"></v-combobox>
            </div>
            <div class="col">
              <v-text-field autocomplete="off" name="heigth" label="Alto" :rules="item.heigth ? [rules.decimal] : []" type="number" v-model="item.heigth" />
            </div>
            <div class="col">
              <v-text-field autocomplete="off" name="width" label="Ancho" :rules="item.width ? [rules.decimal] : []" type="number" v-model="item.width" />
            </div>
            <div class="col">
              <v-text-field autocomplete="off" name="length" label="Largo" :rules="item.length ? [rules.decimal] : []" type="number" v-model="item.length" />
            </div>
          </div>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red" text @click="$emit('updateDialog')"> Cancelar </v-btn>
        <v-btn color="green" text @click="addNewPresentation()"> {{ itemEdit != null ? "Editar" : "Agregar" }} </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Constant from "@/constants/sections";
import { generalService } from "@/libs/ws/generalService";
import ValidMixin from "@/mixins/ValidMixin.vue";
export default {
  created() {},
  mixins: [ValidMixin],
  components: {},
  props: {
    dialog: Boolean,
    product: Object,
    updateDialog: Function,
    addPresentation: Function,
    itemEdit: Object,
    isEdit: Boolean
  },
  computed: {
    filteredPresentationTypes() {
      // Si no hay otras presentaciones disponibles, es una presentación base
      // Solo mostrar "Caja" o "Unidad"
      if (this.getPresentations(this.item).length === 0) {
        return this.presentation_types.filter(type => type.id != 3); // Suponiendo que 'Caja' tiene id 1 y 'Unidad' tiene id 2
      }
      // Si hay otras presentaciones, mostrar todos los tipos
      return this.presentation_types;
    }
  },
  data: () => ({
    item: {
      name: "",
      barcode: "",
      presentation_type: null,
      composite_presentation: null,
      amount_composite_presentation: null,
      storage_unit: null,
      weight_unit: null,
      weight: "",
      measure_unit: null,
      heigth: "",
      width: "",
      length: "",
      sellable: true,
    },
    defaultItem: null,
    presentations: [],
    weight_units: [],
    measure_units: [],
    presentation_types: [],
  }),
  watch: {
    dialog() {
      if (this.itemEdit == null) {
        this.item = JSON.parse(JSON.stringify(this.defaultItem));
      } else {
        this.item = JSON.parse(JSON.stringify(this.itemEdit));
      }
    },
  },
  mounted() {
    this.loadComboData();
    this.defaultItem = JSON.parse(JSON.stringify(this.item));
  },
  methods: {
    getPresentations(item) {
      let presentations_aux = this.product.presentations.filter(x => x !== item);

      let merged = this.presentations.concat(presentations_aux);

      // si el item tiene un tipo de presentación seleccionado, saco las que tengan ese mismo type
      if (item.presentation_type && item.presentation_type.id) {
        merged = merged.filter(p => 
          !p.presentation_type || p.presentation_type.id !== item.presentation_type.id
        );
      }

      // hago unique por presentation_type.id
      const unique = [];
      const seen = new Set();

      for (const p of merged) {
        const typeId = p.presentation_type ? p.presentation_type.id : null;
        if (!seen.has(typeId)) {
          seen.add(typeId);
          unique.push(p);
        }
      }

      return unique;
    },

    loadComboData() {
      generalService.request(Constant.SECTION_UNITS + "/list_measure_units").then((response) => {
        this.measure_units = response.result.list;
      });
      generalService.request(Constant.SECTION_UNITS + "/list_weight_units").then((response) => {
        this.weight_units = response.result.list;
      });
      generalService.request(Constant.SECTION_UNITS + "/list_presentation_types").then((response) => {
        this.presentation_types = response.result.list;
      });

      if (this.product.id > 0)
        generalService.request(Constant.SECTION_PRODUCTS + "/presentations", "POST", { product: this.product.id }).then((response) => {
          this.presentations = response.result.list;
        });
    },
    async addNewPresentation() {
      //completo el campo name con el nombre de la presentacion
      if (this.item.presentation_type && this.item.presentation_type.name) {
        this.item.name = this.item.presentation_type.name;
      }

      const { valid } = await this.$refs.form.validate();
      console.log("valid", valid, this.$refs.form);
      console.log(this.item.amount_composite_presentation);
      if (valid) {
        this.$emit("addPresentation", this.item);
      }
    },
  },
};
</script>
